module.exports = __webpack_public_path__ + "img/Motisonsshares2.e0a5561f.jpeg";